import * as React from 'react';
import { connect } from 'react-redux';
import { signUpGuest, signOut } from '../../actions/authActions';
import { navigateTo } from '../../actions/navigationActions';
import { DASHBOARD } from '../../routes/routes';
import { Button } from 'react-bootstrap';
import { avaragePassword, strongPassword, validateEmail } from './../../constants/validation';
import KPInputTextArea from '../BaseTemplate/SSPCustomComponentLibrary/KPInputTextArea/KPInputTextArea';
import { SA_COUNTRY_ID_NUMBER, NAM_COUNTRY_ID_NUMBER } from './../../constants/internationalization';
import '../RegisterUser/RegisterUser.css'
import './GuestSignup.css'
import {showRequestOTPModal} from "../../actions/modalActions";

class GuestSignup extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            email: '',
            password: '',
            passwordTwo: '',
            pwHide: true,
            pwHasFocus:false,
            passwordMatch: true,
            isStrongPassword: false,
            isAvaragePassword: false,
            isWeakPassword: false,
            mailRegex: true,
            acceptedTCs: false,
            noticeType: '',
            submitted: false,
            btnNextDisabled: false,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
        this.handleToggleTC = this.handleToggleTC.bind(this);
        this.handleSignOut = this.handleSignOut.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
    }

    componentWillMount() {
        if (this.props.auth.provider !== "anon") {
            this.props.dispatchAction(navigateTo(DASHBOARD));
        }
        else {
            this.checkSubmit();
        }
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;

        await this.setState({ [name]: value });
        await this.checkSubmit();
    }

    async handleToggleTC() {
        await this.setState({ acceptedTCs: !this.state.acceptedTCs });
        await this.checkSubmit();
    }

    async checkSubmit() {
        let valid = true;
        const { email, password, passwordTwo } = this.state;

        await this.setState({mailRegex: true, isWeakPassword: false, isAvaragePassword: false, isStrongPassword: false, noticeType: '' });

        if (!validateEmail.test(email)) {
            valid = false;
            this.setState({ mailRegex: false });
        }

        if (password === "") {
            valid = false;
        }
        else {
            if (strongPassword.test(password)) {
                await this.setState({ isStrongPassword: true, noticeType: 'success', noticeMessage: 'The force is strong with this 1. Please continue.' });
            } else if (avaragePassword.test(password)) {
                await this.setState({ isAvaragePassword: true, noticeType: 'warning', noticeMessage: 'You’re getting warmer… Add some lower/upper case characters.' });
                valid = false;
            } else {
                await this.setState({ isWeakPassword: true, noticeType: 'error', noticeMessage: "Woah, that's too easy! Your password should be at least 8 characters and contain uppercase and lowercase letters, numbers, and a special character." });
                valid = false;
            }
            if (passwordTwo === "") {
                valid = false;
            }
        }

        if (!this.state.acceptedTCs) {
            valid = false;
        }

        this.setState({ btnNextDisabled: !valid });
    }

    async handleRegister(e: any) {
        const { password, passwordTwo } = this.state;

        if (password === passwordTwo) {
            await this.setState({ submitted: true, passwordMatch: true });
            await this.props.dispatchAction(signUpGuest(this.state.email, this.state.password));
        }
        else {
            await this.setState({ passwordMatch: false });
        }

        this.setState({ submitted: true });
    }

    handleSignOut() {
        this.props.dispatchAction(signOut());
    }

    render() {
        let pwStrengthClass = this.state.isStrongPassword ? "strong" : this.state.isAvaragePassword ? "average" : "weak";
        let pwStrengthText = this.state.isStrongPassword ? "Strong" : this.state.isAvaragePassword ? "Average" : "Too weak"; 

        return (
            <div id="GuestContainer" className="container justify-content-center text-center pt-10">
                <div className="header-large">
                    Yay, your policy is created
                </div>

                <div className="mt-4">
                    <h3>Your policy no. {this.props.profile.guestPolicyNumber}</h3>
                    <h3>Sign up to view your policy</h3>
                </div>

                <div className="row mt-4">
                    <div className="col-lg-6 offset-lg-3">
                        <KPInputTextArea
                            id="RegisterInputEmail"
                            name="email"
                            type="email"
                            className="mb-15px"
                            label={"Email"}
                            showLabelAfterSelection={true}
                            value={this.state.email}
                            notice={this.state.submitted && !this.state.mailRegex}
                            noticeType={"error"}
                            noticeMessage={"A valid email is required"}
                            successTick={this.state.mailRegex}
                            required={false}
                            readOnly={false}
                            autoFocus={false}
                            minLength={10}
                            maxLength={false}
                            disabled={false}
                            form="mainform"
                            handleChange={(e) => this.handleChange(e)}
                        />

                        <KPInputTextArea
                            id="RegisterInputPassword"
                            name="password"
                            type="password"
                            className="mb-15px"
                            label={"Password"}
                            showLabelAfterSelection={true}
                            value={this.state.password}
                            notice={true}
                            noticeType={this.state.noticeType}
                            noticeMessage=""
                            successTick={false}
                            required={false}
                            readOnly={false}
                            autoFocus={false}
                            minLength={10}
                            maxLength={false}
                            disabled={false}
                            form="mainform"
                            handleChange={(e) => this.handleChange(e)}
                            onFocus={() => this.setState({ pwHasFocus: true })}
                            onBlur={() => this.setState({ pwHasFocus: false })}
                        />

                        
                        {this.state.pwHasFocus && 
                            <div className="pwTips mb-2">
                                Pick a password that:<br/>
                                - Has at least 8 characters.<br />
                                - Contains a number.<br />
                                - Contains a special character.
                            </div>
                        }

                        {!this.state.pwHasFocus && this.state.password !== "" &&
                            <div className="mb-2">
                                <div className="pwStrength">
                                    Password strength: <span className={pwStrengthClass}>{pwStrengthText}</span>
                                </div>

                                <div className="pwNotice mt-2">
                                    {this.state.noticeMessage}
                                </div>
                            </div>
                        }

                        <KPInputTextArea
                            id="LoginInputPassword"
                            name="passwordTwo"
                            type="password"
                            className="mb-15px"
                            label={"Re-type password"}
                            showLabelAfterSelection={true}
                            value={this.state.passwordTwo}
                            notice={!this.state.passwordMatch}
                            noticeType={"error"}
                            noticeMessage={"Oops, your passwords don’t match. Please try again?"}
                            successTick={false}
                            required={false}
                            readOnly={false}
                            autoFocus={false}
                            minLength={10}
                            maxLength={false}
                            disabled={false}
                            form="mainform"
                            handleChange={(e) => this.handleChange(e)}
                        />

                        <div className="ml-20px mr-20px">
                            {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER &&
                                <div className="row mt-4">
                                    <div className="col-1 nopa">
                                        <img className="pr-10px" src="./images/icon-whatsapp-nugreen.svg" alt="" title="" />
                                    </div>
                                    <div className="col-11 nopa">
                                        <p className="byClickNext">By signing up, you agree to receive our WhatsApp notifications. (You can opt out at any time, though.)</p>
                                    </div>
                                </div>
                            }
                            <div className="row mt-4">
                                <div className="col-2 nopa">
                                    <label className="switch">
                                        <input type="checkbox" onClick={this.handleToggleTC} />
                                        <span id="registerCheckbox" className="slider-signup round"></span>
                                    </label>
                                </div>
                                {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER &&
                                    <div className="col-10 nopa">
                                        <p className="switch-normal nopa ml-12px mb-20px">I agree to <a className="w-bold" target="_blank" href="https://www.kingprice.co.za/terms-and-conditions/">King Price’s T’s & C’s</a> and <a className="w-bold" target="_blank" href="https://www.kingprice.co.za/privacy-policy/">POPIA policy</a>.</p>
                                    </div>
                                }
                                {this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER &&
                                    <div className="col-10 nopa">
                                        <p className="switch-normal nopa ml-12px mb-20px">I agree to <a className="w-bold" target="_blank" href="https://www.kingprice.co.na/Home/terms-and-conditions/">King Price’s T’s & C’s</a>.</p>
                                    </div>
                                }
                            </div>
                        </div>
                        
                        <Button type="button" className="btn btn-solid-green btn-lg btn-sign-up mt-4" disabled={this.state.btnNextDisabled} onClick={this.handleRegister} id="Register">Sign up</Button>

                        <div className="mt-4">
                            <p className="link" onClick={this.handleSignOut}>Sign up later</p>
                            <p> {this.props.profile.countryId != NAM_COUNTRY_ID_NUMBER ? "Already a client?" : "Already registered?"} <span className="link" id="SignUp" onClick={this.handleSignOut}>Log in.</span></p>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.auth,
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestSignup);